import ChallengeConfigMealPlanSelector from './ChallengeConfigMealPlanSelector';

export default ChallengeConfigMealPlanSelector;
